$(function () {
    //获取要定位元素距离浏览器顶部的距离
    var navH = $(".new-productView-bar").offset().top + 10;
    // console.log(navH);
    //滚动条事件
    $(window).scroll(function () {
        // console.log($(window).width())
        //获取滚动条的滑动距离
        var scroH = $(this).scrollTop() + 70;
        // console.log(scroH);
        //滚动条的滑动距离大于等于定位元素距离浏览器顶部的距离，就固定，反之就不固定
        if (scroH >= navH) {
            // $(".new-product-tab").css({
            //     "position": "fixed",
            //     "top": 69,
            //     "z-index": 2,
            //     "background-color": "#ECECEE"
            // });
            $(".new-productView-bar").addClass("new-fixed")
            //  $(".new-product-tab").addClass("container-1170")
            $(".new-productView-bar").css({"position": "fixed", "z-index": 100, "width": "100%", "top": 0});

            $(".product-bottom-tabBox").css({"padding-top": 68})
        } else if (scroH < navH) {
            $(".new-productView-bar").removeClass("new-fixed")
            $(".new-productView-bar").css({"position": "static"});
            $(".product-bottom-tabBox").css({"padding-top": 0})
        }
    })
});